import {I18n} from '@lingui/core';
import {MerchantAccountPublicStatus} from '@zentact/common';
import {DateTime} from 'luxon';

interface StatusMapParams {
  expiresAt?: string;
  inPeriodicReviewExpirationDate?: string;
}
export const getLocalizedStatusMap = (
  i18n: I18n,
  params?: StatusMapParams
): Record<MerchantAccountPublicStatus, string> => {
  const {expiresAt, inPeriodicReviewExpirationDate} = params || {};
  return {
    [MerchantAccountPublicStatus.ACTIVE]: i18n._('Active'),
    [MerchantAccountPublicStatus.ACTIVE_IN_PERIODIC_REVIEW]: inPeriodicReviewExpirationDate
      ? (() => {
          const daysDiff = Math.floor(
            Math.abs(
              DateTime.now().diff(DateTime.fromISO(inPeriodicReviewExpirationDate), 'days').days
            )
          );
          return daysDiff === 0
            ? i18n._('Merchant: Review Required in less than a day')
            : i18n._('Merchant: Review Required in {count}d', {count: daysDiff});
        })()
      : i18n._('Active: In Periodic Review'),
    [MerchantAccountPublicStatus.INITIATED]: i18n._('Invite Initiated'),
    [MerchantAccountPublicStatus.INVITED]: expiresAt
      ? i18n._('Invite Sent: {count}d left', {
          count: Math.floor(
            Math.abs(DateTime.now().diff(DateTime.fromISO(expiresAt), 'days').days)
          ),
        })
      : i18n._('Invite Sent'),
    [MerchantAccountPublicStatus.INVITE_ACCEPTED]: i18n._('Invite Accepted'),
    [MerchantAccountPublicStatus.APPLICATION_IN_PROGRESS]: i18n._('Application In Progress'),
    [MerchantAccountPublicStatus.INVITE_EXPIRED]: i18n._('Invite Expired'),
    [MerchantAccountPublicStatus.INVITE_REVOKED]: i18n._('Invite Revoked'),
    [MerchantAccountPublicStatus.DEACTIVATED]: i18n._('Deactivated'),
    [MerchantAccountPublicStatus.APPLICATION_REVOKED]: i18n._('Application Revoked'),
    [MerchantAccountPublicStatus.APPLICATION_IN_REVIEW]: i18n._('Application In Review'),
    [MerchantAccountPublicStatus.REJECTED]: i18n._('Application Error'),
    [MerchantAccountPublicStatus.NEEDS_ORGANIZATION]: i18n._('Needs Organization Assignment'),
    [MerchantAccountPublicStatus.ASSIGNING_ORGANIZATION]: i18n._('Organization Assigning'),
    [MerchantAccountPublicStatus.ADDITIONAL_DATA_REQUIRED]: i18n._(
      'Application: Additional Data Required'
    ),
    [MerchantAccountPublicStatus.CLOSING]: i18n._('Closing'),
    [MerchantAccountPublicStatus.CLOSED]: i18n._('Closed'),
    [MerchantAccountPublicStatus.SUSPENDED]: i18n._('Suspended'),
    [MerchantAccountPublicStatus.ACTIVE_ALLOWED_APP_CHANGES]: i18n._(
      'Active - Allowed Application Changes'
    ),
  };
};
